import {
  SESSION_EXPIRED_FLAG_KEY,
  apiGet,
  apiPost,
  apiPut,
  clearAccessToken,
  getSessionStatus,
  setAccessToken,
} from './api';

export async function registerUser({ email, password }) {
  const response = await apiPost('/api/auth/register', { email, password });

  if (response.data?.accessToken) {
    setAccessToken(response.data.accessToken);
  }

  return response.data;
}

export async function loginUser({ email, password }) {
  const response = await apiPost('/api/auth/login', { email, password });

  if (response.data?.accessToken) {
    setAccessToken(response.data.accessToken);
  }

  return response.data;
}

export function logoutUser() {
  clearAccessToken();
}

/** @returns {'valid' | 'expired' | 'none'} */
export function consumeSessionStatus() {
  const status = getSessionStatus();

  if (status === 'expired') {
    // Survive React Strict Mode remount so the toast can show after ToastContainer mounts.
    sessionStorage.setItem(SESSION_EXPIRED_FLAG_KEY, '1');
  }

  if (status !== 'valid') {
    clearAccessToken();
  }

  return status;
}

export function restoreSession() {
  return consumeSessionStatus() === 'valid';
}

export async function fetchCurrentUser() {
  return apiGet('/api/auth/user');
}

export async function changePassword({ currentPassword, newPassword }) {
  const data = await apiPut('/api/auth/change-password', {
    currentPassword,
    newPassword,
  });

  return data;
}
